import React, { Fragment, forwardRef, useState, useEffect } from "react";
import { Card, Icon, Avatar, Col, Row, message, Spin } from 'antd';
import Meta from 'antd/es/card/Meta';
import clsx from 'clsx';
import './styles.css';
import { isActive } from 'lib';
import PreloadedImage from 'ReusableComponents/PreloadedImage';

export default forwardRef((props: any, ref: any) => {
  const {
    src,
    title,
    setActiveButton,
    index,
    activeButton,
    correctAnswer,
    checkAnswer,
    ...rest
  } = props;

  return (
    <Fragment>
    { src && (
      <Avatar
        className={clsx('avatar-image', {
          'active': activeButton === index,
          'correct': checkAnswer && correctAnswer,
          'incorrect': checkAnswer && (activeButton === index) && !correctAnswer,
        })}
        onClick={setActiveButton}
        shape="square"
        style={{
          height: '7vw',
          width: '8.4vw',
          borderRadius: 16,
        }}
        icon={<PreloadedImage width={"100%"} image={src} />}
      />
    )}
    { !src && (
      <Avatar
        className={clsx('avatar-text', {
          'active': activeButton === index,
          'correct': checkAnswer && correctAnswer,
          'incorrect': checkAnswer && (activeButton === index) && !correctAnswer,
        })}
        onClick={setActiveButton}
        size={50}
      >
        {title}
      </Avatar>
    )}
    </Fragment>
  )
});